//Imports
import React from "react";
import ResponsiveAppBar from "../../components/appbar";
import Footer from "../../components/footer";
import Chooseperson from "../../components/chooseperson";


//Function Internpage
export default function Intern() {

    return(
        <div className={"Start-background"}>
            <ResponsiveAppBar/>
            <Chooseperson/>


            <Footer/>
        </div>

    );
}